import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';

import CityEditModal from '../../../../components/CityEditModal';
import * as api from '../../../../services/api/admin';

class Cities extends Component {
  state = {
    isLoading: true,
    cities: [],
    cityUnderEdit: {},
    openCityEditModal: false,
  };

  async componentDidMount() {
    const { enqueueSnackbar } = this.props;

    try {
      this.setState({ isLoading: true });
      await this.fetchAllCities();
    } catch (err) {
      console.error(err);
      enqueueSnackbar(
        'Unable to fetch cities, please refresh the page to try again.'
      );
    } finally {
      this.setState({ isLoading: false });
    }
  }

  fetchAllCities = async () => {
    const cities = await api.fetchAllCities();
    this.setState({ cities });
  };

  onNewCity = async () => {
    this.setState({ openCityEditModal: true, cityUnderEdit: {} });
  };

  onEditCity = async city => {
    this.setState({ openCityEditModal: true, cityUnderEdit: city });
  };

  onSaveCity = async city => {
    const { enqueueSnackbar } = this.props;

    try {
      if (city.id) {
        await api.updateCity(city);
      } else {
        await api.createCity(city);
      }
      enqueueSnackbar('City saved!');
      this.onClose();
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to save city, please try again.');
    } finally {
      this.fetchAllCities();
    }
  };

  onClose = () => {
    this.setState({ openCityEditModal: false, cityUnderEdit: {} });
  };

  render() {
    const { classes } = this.props;
    const { isLoading, cities, cityUnderEdit, openCityEditModal } = this.state;

    if (isLoading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cities.map(city => (
              <TableRow key={city.id}>
                <TableCell width="800">{city.name}</TableCell>
                <TableCell>
                  <IconButton onClick={() => this.onEditCity(city)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Grid
          container
          justifyContent="flex-end"
          classes={{ container: classes.actions }}
        >
          <Grid item xs={12} md={6} lg={2}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={this.onNewCity}
            >
              + Add City
            </Button>
          </Grid>
        </Grid>

        {openCityEditModal && (
          <CityEditModal
            city={cityUnderEdit}
            open={openCityEditModal}
            save={this.onSaveCity}
            onClose={this.onClose}
          />
        )}
      </>
    );
  }
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actions: {
    marginTop: '2em',
  },
});

export default withSnackbar(withStyles(styles)(Cities));
